import Avatar from "../asset/images/defaultImgs/defaultAvatar.jpg";
import ClubImg from "../asset/images/Logo(NoBg).webp";

export const defaultImgs = {
  Avatar: Avatar,
  ClubImg: ClubImg,
};
